export default __webpack_public_path__ + "4b1f80060b1a3f5aedf4f2b9c5540851.jpg";